import { useCallback } from 'react';
import { Stack } from '@mui/material';
import DatePicker from 'components/Common/DatePicker';
import TimePicker from 'components/Common/TimePicker';
import { combineDate, combineTime } from 'utils/helpers';

interface DateAndTimePickerTypes {
    date: string | Date;
    setDateAndTime: (date: string) => void;
    defaultNull?: boolean;
    disableDate?: boolean;
    disableTime?: boolean;
    dateLabel?: string;
    timeLabel?: string;
}

const DateAndTimePicker = ({
    date,
    setDateAndTime,
    defaultNull,
    disableTime,
    disableDate,
    dateLabel,
    timeLabel,
}: DateAndTimePickerTypes) => {
    const defaultProps = {
        value: date,
        defaultNull,
    };

    const handleDateChange = useCallback(
        (newDate: string | Date) => {
            const combinedDateTime = combineDate(date, newDate);
            if (!combinedDateTime) {
                return;
            }
            setDateAndTime(combinedDateTime);
        },
        [date, setDateAndTime]
    );

    const handleTimeChange = useCallback(
        (newTime: string | Date) => {
            const combinedDateTime = combineTime(date, newTime);
            if (!combinedDateTime) {
                return;
            }
            setDateAndTime(combinedDateTime);
        },
        [date, setDateAndTime]
    );

    return (
        <Stack direction={{ md: 'row' }} gap={{ xs: 2, md: 4 }} style={{ marginTop: 4 }}>
            <DatePicker {...defaultProps} setValue={handleDateChange} disabled={disableDate} label={dateLabel} />
            <TimePicker {...defaultProps} setValue={handleTimeChange} disabled={disableTime} label={timeLabel} />
        </Stack>
    );
};

export default DateAndTimePicker;
